
<template>
 <div class="iframe_div">
  <iframe :src="url" class="iframe"  width="100%" height="90%"/>
  <div class="type" @click="closeiframe">返回</div>
  </div>
</template>
 
<style>
.iframe_div{
	width:100%;
	height:100%;
	position: fixed;
	top: 0;
    right: 0;
	left: 0;
	bottom: 0;
	background-color: white;
	display: flex;
	justify-content: space-around;
	align-items: center;
	flex-direction: column;
}
.iframe_div .type {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.2rem;
  height: 0.78rem;
  background: #28cc77;
  border-radius: 0.08rem;
  font-size: 0.32rem;
  color: #ffffff;
}
</style>
 
<script>

export default {
  name: 'IFrameModal',
  props: {  
	url:String
  },
  data() {
    return {
		
	  }
  }, 
  watch:{
	  url:{
		  handler(val){
			  if(val!=this.url){
				  this.url=val
			  }
		  },
		  immedieta:true,
	  }
  },
  methods: {  
	closeiframe:function(){
		this.$emit("closeiframe");
	}
  }
}
</script>